import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { InlineSubnav } from 'site-modules/editorial/components/type/one-column/inline-subnav/inline-subnav';
import { ExcoVideoViewerBlueBg } from 'site-modules/shared/components/exco-video/exco-video-viewer-blue-bg';

import './article-content.scss';

export function ArticleContent({ content = null, entry = DEFAULT_CONTENT, highlight = false, index = -1 }) {
  if (!content) {
    return null;
  }

  const subnav = entry.hasChild('subnav') ? entry.child('subnav') : null;

  return (
    <Fragment>
      <ContentFragment
        classes={classnames('article-content', {
          'highlight ps-1_5 pe-lg-3_5 me-lg-3_5': highlight,
        })}
        inlineStyle={
          highlight
            ? {
                minHeight: '160px',
                marginTop: '2rem',
                marginBottom: '2rem',
                lineHeight: '2rem',
                fontWeight: '400',
                fontSize: '1.5rem',
              }
            : null
        }
      >
        {content}
      </ContentFragment>
      {index === 0 && (
        <Fragment>
          <br />
          <ExcoVideoViewerBlueBg />
        </Fragment>
      )}
      {!!subnav && <InlineSubnav entry={subnav} />}
    </Fragment>
  );
}

ArticleContent.propTypes = {
  content: PropTypes.string,
  entry: CmsEntities.Content,
  highlight: PropTypes.bool,
  index: PropTypes.number,
};
